import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { useBilling } from '../contexts/BillingContext';

export const BillingBanner = () => {
  const { showBanner, status, daysToDue, overdueDays } = useBilling();
  const location = useLocation();

  if (!showBanner) return null;
  // Não mostra na própria página de billing ou no login/master
  if (['/billing', '/login', '/master'].some((p) => location.pathname.startsWith(p))) return null;

  const isOverdue = overdueDays > 0;
  const bg = isOverdue ? 'bg-red-600' : 'bg-amber-500';
  const text = isOverdue
    ? `Liberação do sistema VENCIDA há ${overdueDays} dia(s). Sistema será bloqueado em breve.`
    : daysToDue === 0
    ? 'Liberação do sistema vence HOJE.'
    : `Liberação do sistema vence em ${daysToDue} dia(s).`;

  return (
    <div
      data-testid="billing-banner"
      className={`${bg} text-white px-4 py-2 flex items-center justify-between gap-3 text-sm font-medium`}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle size={18} />
        <span>{text}</span>
        {status?.subscription?.amount && (
          <span className="hidden sm:inline opacity-90">
            • R$ {Number(status.subscription.amount).toFixed(2)}
          </span>
        )}
      </div>
      <Link
        to="/billing"
        data-testid="billing-banner-link"
        className="bg-white text-slate-900 px-3 py-1 rounded text-xs font-semibold hover:bg-slate-100 flex items-center gap-1"
      >
        <CreditCard size={14} /> Pagar agora
      </Link>
    </div>
  );
};
